import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { TransactionStatusEnum } from '@blockcatio/tabby-library/lib/constants';

class RedeemReward extends React.PureComponent {
  render() {
    const {
      redemptionStatus, didSend, errorMessage, onRedeemReward,
    } = this.props;
    return (
      <div className="redeem-reward">
        <h1>Redeem Your Code</h1>
        {errorMessage && <p className="error">{errorMessage}</p>}
        {didSend &&
          redemptionStatus === TransactionStatusEnum.pending && (
            <p className="success">Your code redemption is processing, it will complete shortly.</p>
          )}
        {redemptionStatus === TransactionStatusEnum.succeeded && (
          <p className="success">Your code redemption completed successfully!</p>
        )}
        {redemptionStatus === TransactionStatusEnum.failed && (
          <p className="error">Your code redemption failed!</p>
        )}
        <button className="btn" type="button" onClick={onRedeemReward}>
          Redeem Now
        </button>
      </div>
    );
  }
}

RedeemReward.displayName = 'RedeemReward';

RedeemReward.defaultProps = {
  errorMessage: '',
  didSend: false,
  redemptionStatus: TransactionStatusEnum.pending,
  onRedeemReward: noop,
};

RedeemReward.propTypes = {
  errorMessage: PropTypes.string,
  didSend: PropTypes.bool,
  redemptionStatus: PropTypes.number,
  onRedeemReward: PropTypes.func,
};

export default RedeemReward;



// WEBPACK FOOTER //
// ./src/containers/redeemReward/RedeemReward.js